module.exports = __webpack_public_path__ + "static/house_render_3-b80878d591675015718412441bbe40b5.jpg";